import React from 'react';
import {observable, action, runInAction, toJS} from 'mobx';
import {observer} from 'mobx-react';
import {Row, Col, Switch, Modal, Button, Form, Upload, Avatar, Card, message, Divider, Table, Collapse} from 'antd';
import orderDetailStore from '@store/User/UserList/OrderDetailStore';

const Panel = Collapse.Panel;

@observer
class OrderDetailMatchTableModal extends React.Component {

  columns = [
    {
      title: '星期',
      dataIndex: 'week'
    },
    {
      title: '比赛编号',
      dataIndex: 'bout_index'
    },
    {
      title: '赛事名',
      dataIndex: 'match_name'
    },
    {
      title: '比赛时间',
      dataIndex: 'match_time'
    },
    {
      title: '主队VS客队',
      render(text, record, index) {

        if (record.isJCZQ)
        {
          return ( <span>{record.home_team}VS{record.awary_team}</span>)
        }
        else
        {
          return (<span>{record.awary_team}VS{record.home_team}</span>)
        }
      }
    },
    {
      title: '让球数',
      render(text, record, index) {
        if (record.isJCLQ)
        {
          let style = {
            color: 'red',
            fontWeight: '700'
          };

          let concede = record.concede;
          let hasSpecial = false;

          record.betItemList.forEach(function (item) {
            if (item.isLQSpecial())
            {
              concede = item.betSpecial;
              hasSpecial = true;
            }
          });

          if (hasSpecial)
          {
            return (
              <span style={style}>{concede}</span>
            )
          }

          return (
            <span>{concede}</span>
          )
        }
        return (
          <span>{record.concede}</span>
        )
      }
    },
    {
      title: '投注项',
      render(text, record, index) {

        let redStyle = {
          color: 'red'
        };

        let boldStyle = {
          fontWeight: '900'
        };

        return (
          <div>
            {
              record.betItemList.map(function (data,index) {

                return (
                  <div key={index} style={data.isWin?redStyle:{}}>
                    {data.betTypeName}:
                    <span style={boldStyle}>{data.betResultName}</span>
                    ({data.betRadio})
                  </div>
                )
              })
            }
          </div>
        )
      }
    }
  ];

  jczq_columns = [
    {
      title: '全场比分结果',
      dataIndex: 'match_result_data.whole_score'
    },
    {
      title: '半场比分结果',
      dataIndex: 'match_result_data.half_score'
    },
    {
      title: '胜平负结果',
      dataIndex: 'match_result_data.spf_result_name'
    },
    {
      title: '让球胜平负结果',
      dataIndex: 'match_result_data.rqspf_result_name'
    },
    {
      title: '半全场结果',
      dataIndex: 'match_result_data.bqc_result_name'
    },
    {
      title: '进球数结果',
      dataIndex: 'match_result_data.jqs_result'
    }
  ];
  jclq_columns = [
    {
      title: '全场比分结果',
      dataIndex: 'match_result_data.whole_score'
    },
    {
      title: '胜负结果',
      dataIndex: 'match_result_data.sf_result_name'
    },
    {
      title: '让分胜负结果',
      dataIndex: 'match_result_data.rfsf_result_name'
    },
    {
      title: '大小分结果',
      dataIndex: 'match_result_data.dxf_result_name'
    },
    {
      title: '胜分差结果',
      dataIndex: 'match_result_data.sfc_result_name'
    }
  ];

  constructor() {
    super();
    this.state = {someKey: 'someValue'};
  }

  currentTitle(currentPageData) {
    let style = {
      color: 'black',
      fontWeight: '900'
    }
    return (
      <div>过关方式:[<span style={style}>{orderDetailStore.orderDetailData.touzhu_style}</span>]</div>
    );
  }


  render() {

    const customPanelStyle = {
      background: '#f7f7f7',
      borderRadius: 4,
      border: 0,
      overflow: 'hidden',
    };


    //竞彩足球和篮球的列不一样
    let columns = this.columns;
    if (orderDetailStore.orderDetailData.isJCZQ) {
      columns = columns.concat(this.jczq_columns);
    }
    else if (orderDetailStore.orderDetailData.isJCLQ) {
      columns = columns.concat(this.jclq_columns);
    }

    return (
      <Collapse defaultActiveKey={['1']} bordered={false}>
        <Panel header="比赛明细" key="1" style={customPanelStyle}>
          <Table
            title={this.currentTitle}
            size='small'
            dataSource={toJS(orderDetailStore.orderDetailData.match_data)}
            columns={columns}
            rowKey={(record) => {
              return record.id;
            }
            }
            pagination={false}
            bordered/>
        </Panel>
      </Collapse>
    );
  }

  componentDidMount() {
    this.setState({someKey: 'otherValue'});
  }
}

export default OrderDetailMatchTableModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/Order/OrderDetailMatchTableModal.jsx